module.exports = __webpack_public_path__ + "static/GetStarted-1-b6bb187c8b521a70f12eabb0d40eb711.jpg";